import React, { useState } from "react";
import { Link } from "react-router-dom";
import Image1 from "../../assets/images/slide1.jpeg";
import Image2 from "../../assets/images/lib2.jpg";
import Image5 from "../../assets/images/science-lab.jpg";
import Image6 from "../../assets/images/science-lab2.jpg";
import Image3 from "../../assets/images/cap.webp";
import Image4 from "../../assets/images/cap2.webp";
import HOD from "../../assets/images/hod.png";
import Dir1 from "../../assets/images/charity.png";
import Dir2 from "../../assets/images/oamen.png";
import Dir3 from "../../assets/images/tamu.png";
import "./home.scss";
import Carousel from "react-bootstrap/Carousel";
import MovingComponent from "react-moving-text";
import { popularCourses, latestNews, latestEvents } from "../../TextData";
import { Courses } from "../../components/Courses/Courses";
import CountUp from "react-countup";
import { News } from "../../components/News/News";
import { Events } from "../../components/Events/Events";

export const Home = () => {
  const [state, setState] = useState({
    query: "",
    list: popularCourses,
    list2: latestNews.filter((newsItem) => {
      return newsItem.id <= 4;
    }),
    list3: latestEvents,
  });
  return (
    <>
      <Carousel fade>
        <Carousel.Item>
          <div className="home-container">
            <img className="" src={Image1} alt="Scholar" width="100%" />
            <div class="overlay">
              <div className="col-md-5 offset-md-6 offset-6">
                <h1>
                  <MovingComponent
                    type="slideInFromTop"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="ease"
                    iteration="1"
                    fillMode="none"
                  >
                    Exploring the Boundaries of Physics, Shaping the Future of
                    Science
                  </MovingComponent>
                </h1>
                <p>
                  <MovingComponent
                    type="slideInFromTop"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="ease"
                    iteration="1"
                    fillMode="none"
                  >
                    {" "}
                    Physics knows no bounds, and neither do we. Join us in
                    exploring the boundaries of physics, pushing the limits of
                    human understanding, and shaping the future of science. Our
                    department is a hub of innovation, where groundbreaking
                    research and transformative discoveries are a way of life.
                  </MovingComponent>
                </p>
                <Link to={"/course-page"} className="cources-btn">
                  View courses
                </Link>
              </div>
            </div>
          </div>{" "}
        </Carousel.Item>{" "}
        <Carousel.Item>
          <div className="home-container">
            <img className="" src={Image2} alt="Scholar" width="100%" />
            <div class="overlay2">
              <div className="col-md-5 offset-md-6">
                <h1>
                  <MovingComponent
                    type="slideInFromTop"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="ease"
                    iteration="1"
                    fillMode="none"
                  >
                    Connecting Quantum Leaps to Everyday Life: It Starts Here
                  </MovingComponent>
                </h1>

                <p>
                  <MovingComponent
                    type="slideInFromLeft"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="linear"
                    iteration="1"
                    fillMode="none"
                  >
                    Quantum leaps in physics may seem abstract, but they have
                    profound implications for everyday life. Join us as we
                    bridge the gap between quantum theory and practical
                    applications
                  </MovingComponent>
                </p>
                <Link to={"/course-page"} className="cources-btn">
                  View courses
                </Link>
              </div>
            </div>
          </div>{" "}
        </Carousel.Item>{" "}
        <Carousel.Item>
          <div className="home-container">
            <img className="" src={Image5} alt="Scholar" width="100%" />
            <div class="overlay2">
              <div className="col-md-5 offset-md-6">
                <h1>
                  <MovingComponent
                    type="slideInFromTop"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="ease"
                    iteration="1"
                    fillMode="none"
                  >
                    Transforming Theories into Realities:
                  </MovingComponent>
                </h1>

                <p>
                  <MovingComponent
                    type="slideInFromLeft"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="linear"
                    iteration="1"
                    fillMode="none"
                  >
                    Theoretical physics has the power to transform the world,
                    and our department is dedicated to turning theories into
                    realities. We are committed to making a meaningful impact
                    through our research and education. Join us in the pursuit
                    of scientific truth and discover how you can be a part of
                    the transformative journey that is physics.
                  </MovingComponent>
                </p>
                <Link to={"/course-page"} className="cources-btn">
                  View courses
                </Link>
              </div>
            </div>
          </div>{" "}
        </Carousel.Item>{" "}
        <Carousel.Item>
          <div className="home-container">
            <img className="" src={Image6} alt="Scholar" width="100%" />
            <div class="overlay2">
              <div className="col-md-5 offset-md-6">
                <h1>
                  <MovingComponent
                    type="slideInFromTop"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="ease"
                    iteration="1"
                    fillMode="none"
                  >
                    Fueling Curiosity, Igniting Innovation in Physics.
                  </MovingComponent>
                </h1>

                <p>
                  <MovingComponent
                    type="slideInFromLeft"
                    duration="3000ms"
                    delay="0s"
                    direction="normal"
                    timing="linear"
                    iteration="1"
                    fillMode="none"
                  >
                    Curiosity is the driving force behind innovation, and in our
                    department, we fuel that curiosity daily. Through inspiring
                    lectures, hands-on experiments, and collaborative research
                    projects, we ignite the spark of innovation in our students.
                  </MovingComponent>
                </p>
                <Link to={"/course-page"} className="cources-btn">
                  View courses
                </Link>
              </div>
            </div>
          </div>{" "}
        </Carousel.Item>
      </Carousel>

      <div className="why-physics col-md-6">
        <h2 className="offset-md-4">WHY PHYSICS?</h2>
      </div>
      <div className="col-md-12 reason-div d-md-flex">
        <div className="col-md-5 offset-md-2">
          <p className="col-md-11">
            {" "}
            Embarking on a journey of scientific exploration and discovery
            begins here, at the University of Port Harcourt's Department of
            Physics. Our program offers an unparalleled opportunity to delve
            into the captivating world of physics and transform your passion for
            science into a fulfilling career. With a distinguished faculty
            renowned for their expertise and commitment to teaching, you'll
            receive top-notch guidance and mentorship. Our state-of-the-art
            laboratories and cutting-edge research facilities provide an
            immersive learning experience, allowing you to actively engage in
            groundbreaking research from day one.
          </p>
          <Link to={"/welcome"} className="learn-link">
            LEARN NOW
          </Link>
        </div>
        <div className="col-md-4">
          <img src={Image5} width="" />
        </div>
      </div>
      <div className="popular-cources">
        <center>
          <h2>POPULAR COURSES</h2>
          <p>Explore the Key Disciplines in Physics</p>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image3} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        <div className="col-md-8 offset-md-2  row row-cols-1 row-cols-lg-3 g-2 g-lg-4 mt">
          {state.list.map((data, index) => (
            <Courses data={data} key={"K" + index} />
          ))}
        </div>
      </div>
      <center>
        <Link to={"/course-page"} className="courses-link">
          Browse All Courses
        </Link>
      </center>
      <div className="statistics mt">
        <center>
          <h1>IMPORTANT FACTS</h1>
          <p>Significant Data</p>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image4} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        <div className="col-md-8 offset-md-2 flexy mt7">
          <div className="col-md-3">
            <center>
              <h2>
                L<span>ecture</span>rs
              </h2>
              <h1 className="stats">
                {" "}
                <CountUp
                  start={0}
                  end={79}
                  duration={2}
                  decimal=""
                  prefix=" "
                  suffix="+"
                  enableScrollSpy={true}
                />
              </h1>
            </center>
          </div>{" "}
          <div className="col-md-3">
            <center>
              <h2>
                Un<span>it Lo</span>ads
              </h2>
              <h1 className="stats">
                {" "}
                <CountUp
                  start={0}
                  end={84}
                  duration={2}
                  decimal=""
                  prefix=" "
                  suffix="+"
                  enableScrollSpy={true}
                />
              </h1>
            </center>
          </div>{" "}
          <div className="col-md-3">
            <center>
              <h2>
                C<span>ourse</span>s
              </h2>
              <h1 className="stats">
                {" "}
                <CountUp
                  start={0}
                  end={18}
                  duration={2}
                  decimal=""
                  prefix=" "
                  suffix="+"
                  enableScrollSpy={true}
                />
              </h1>
            </center>
          </div>{" "}
          <div className="col-md-3">
            <center>
              <h2>
                S<span>tuden</span>ts
              </h2>
              <h1 className="stats">
                {" "}
                <CountUp
                  start={0}
                  end={500}
                  duration={2}
                  decimal=""
                  prefix=" "
                  suffix="+"
                  enableScrollSpy={true}
                />
              </h1>
            </center>
          </div>
        </div>
      </div>
      <div className="col-md-12 news-section">
        <center>
          <h1>LATEST NEWS </h1>
          <p>Stay Informed with Real-time Updates</p>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image3} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        <div className="col-md-8 offset-md-2  row row-cols-1 row-cols-lg-2 g-2 g-lg-3 mt">
          {state.list2.map((data, index) => (
            <News data={data} key={"m" + index} />
          ))}
        </div>
        <center className="mt">
          <Link to={"/news-page"} className="courses-link ">
            View all news
          </Link>
        </center>
      </div>
      <div className="col-md-12 directors-div">
        <center>
          <h1>Board of Directors</h1>
        </center>
        <div className="col-md-10 offset-md-1 flexy">
          <div className="col-md-3">
            {" "}
            <img className="" src={HOD} alt="Scholar" width="100%" />
            <center>
              <h6>Prof. Felix Ugbana Nte</h6>
            </center>
          </div>
          <div className="col-md-3">
            {" "}
            <img className="" src={Dir1} alt="Scholar" width="100%" />
            <center>
              <h6>Prof. Charity Ukpok-Awaji Okujagu</h6>
            </center>
          </div>
          <div className="col-md-3">
            {" "}
            <img className="" src={Dir2} alt="Scholar" width="100%" />
            <center>
              <h6>Prof. Oamen E. Abumere</h6>
            </center>
          </div>
          <div className="col-md-3">
            {" "}
            <img className="" src={Dir3} alt="Scholar" width="100%" />
            <center>
              <h6>Prof. Tamunouni M. Abbey</h6>
            </center>
          </div>
        </div>
        <br />
        <br />
        <center>
          {" "}
          <Link to={"/directory"}>View Directory</Link>
        </center>
      </div>
      <div className="events-section">
        <center>
          <h1>OUR EVENTS</h1>
          <p>Stay In the Loop</p>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image3} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        <div className="col-md-8 offset-md-2  row row-cols-1 row-cols-lg-3 g-2 g-lg-3 mt">
          {state.list3.map((data, index) => (
            <Events data={data} key={"l" + index} />
          ))}
        </div>
      </div>
    </>
  );
};
